<template>
    <b-card title="" class="trigger-card p-2 pb-4 mb-2" no-body>
        <template #header class="p-2">
            <div class="d-flex justify-content-between align-items-center w-100">
                <div class="d-flex align-items-start">
                    <h6 class="text-primary mr-2">Send for <b>Properties</b></h6>

                    <div
                        v-b-tooltip.hover="{ container: 'vue-app', variant: 'info' }"
                        title="You can select properties which will be included/excluded in this trigger."
                        class="text-primary font-italic cursor-pointer d-flex"
                    >
                        <font-awesome-icon :icon="['fas', 'circle-info']"></font-awesome-icon>
                    </div>
                </div>
            </div>
        </template>
        <b-card-body class="p-2">
            <div class="readonly-overlay" v-if="readonly"></div>
            <b-collapse visible id="collapse_properties">
                <hr class="m-0 mb-3" />

                <b-row class="pt-2 mx-lg-5">
                    <b-col md="2">
                        <form-dropdown
                            class="mb-0"
                            :value="propertiesSelectType"
                            :options="propertiesSelectTypeOptions"
                            @input="onSelectType"
                            :disabled="readonly"
                        />
                    </b-col>
                    <b-col md="1" class="d-flex justify-content-center mt-2 mb-2"> For </b-col>
                    <b-col md="9">
                        <validation-provider
                            
                            :rules="propertiesSelectType !== 2 ? 'required' : ''"
                            v-slot="{ errors, handleChange }"
                            name="properties"
                        >
                            <form-dropdown
                                class="mb-0"
                                :value="properties"
                                :isSearch="true"
                                :options="propertiesOptions"
                                :multiSelect="true"
                                @input="
                                    (val) => {
                                        onSelectProperty(val);
                                        handleChange(val);
                                    }
                                "
                                placeholder="Select properties"
                                :error="errors[0]"
                                :disabled="propertiesSelectType === 2 || readonly"
                            />
                        </validation-provider>
                    </b-col>
                </b-row>
            </b-collapse>
        </b-card-body>
    </b-card>
</template>

<script>
    import { mapGetters } from 'vuex';
    import FormDropdown from '../../../generic/form-dropdown/form-dropdown.vue';
    export default {
        components: {
            FormDropdown,
        },
        computed: {
            ...mapGetters('trigger', [
                'propertiesSelectType',
                'propertiesSelectTypeOptions',
                'propertiesOptions',
                'properties',
                'readonly',
            ]),
        },
        methods: {
            onSelectProperty(value) {
                this.$store.commit('trigger/setProperties', value);
                this.$store.commit('trigger/setEditing', true);
            },
            onSelectType(value) {
                this.$store.commit('trigger/setPropertiesSelectType', value);
                this.$store.commit('trigger/setEditing', true);
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '../styles.scss';
</style>
